import CompaniesService from "@/services/companies.service";

const SET_LOADING = "setloading";
const SET_LOADING_MORE = "setMerchantsLoadingMore";
const SET_ALL_MERCHANTS = "setAllMerchants";
const APPEND_MERCHANTS = "appendMerchants";
const SET_MERCHANTS_PAGINATION = "setMerchantsPagination";
const SET_MERCHANTS_SEARCH_RESULTS = "setMerchantsSearchResults";
const SET_MERCHANTS_SEARCH_LOADING = "setMerchantsSearchLoading";
const SET_ALL_EMAIL_CONFIGS = "setAllEmailConfigs";

export const GET_ALL_MERCHANTS = "getAllMerchants";
export const LOAD_MORE_MERCHANTS = "loadMoreMerchants";
export const SEARCH_MERCHANTS = "searchMerchants";
export const CLEAR_MERCHANTS_SEARCH = "clearMerchantsSearch";
export const GET_ALL_MERCHANT_EMAIL_CONFIGS_LIST = "gettAllMerchantEmailConfigList";

export default {
  state: {
    merchants: [],
    merchantsNextPageUrl: null,
    merchantsTotal: null,
    merchantsLoadingMore: false,
    merchantsSearchResults: [],
    merchantsSearchLoading: false,
    loading: false,
    total: null,
    date_range_list: [],
    emailConfigsList: [],
  },
  mutations: {
    [SET_LOADING](state, loading) {
      state.loading = loading;
    },
    [SET_LOADING_MORE](state, loading) {
      state.merchantsLoadingMore = loading;
    },
    [SET_ALL_MERCHANTS](state, payload) {
      state.merchants = Array.isArray(payload) ? payload : [];
    },
    [APPEND_MERCHANTS](state, payload) {
      state.merchants = state.merchants.concat(Array.isArray(payload) ? payload : []);
    },
    [SET_MERCHANTS_PAGINATION](state, { next, total }) {
      state.merchantsNextPageUrl = next || null;
      state.merchantsTotal = total != null ? total : null;
    },
    [SET_MERCHANTS_SEARCH_RESULTS](state, payload) {
      state.merchantsSearchResults = Array.isArray(payload) ? payload : [];
    },
    [SET_MERCHANTS_SEARCH_LOADING](state, loading) {
      state.merchantsSearchLoading = loading;
    },
    [SET_ALL_EMAIL_CONFIGS](state, payload) {
      state.emailConfigsList = payload;
    },
  },
  actions: {
    [GET_ALL_MERCHANTS]({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        if (state.merchants.length > 0 && !params?.forceRefresh) {
          return resolve(state.merchants);
        }
        commit(SET_LOADING, true);
        const queryParams = { ...params, list_view: 'True', page_size:20 };
        CompaniesService.query(queryParams)
          .then((response) => {
            const list = Array.isArray(response?.data) ? response.data : [];
            const next = response?.next ?? null;
            const total = response?.count ?? null;
            commit(SET_ALL_MERCHANTS, list);
            commit(SET_MERCHANTS_PAGINATION, { next, total });
            commit(SET_LOADING, false);
            resolve(state.merchants);
          })
          .catch((error) => {
            console.log(error);
            commit(SET_LOADING, false);
            reject(error);
          });
      });
    },
    [LOAD_MORE_MERCHANTS]({ commit, state }) {
      if (!state.merchantsNextPageUrl || state.merchantsLoadingMore) {
        return Promise.resolve(state.merchants);
      }
      commit(SET_LOADING_MORE, true);
      return CompaniesService.getByUrl(state.merchantsNextPageUrl)
        .then((response) => {
          const list = Array.isArray(response?.data) ? response.data : [];
          const next = response?.next ?? null;
          const total = response?.count ?? null;
          commit(APPEND_MERCHANTS, list);
          commit(SET_MERCHANTS_PAGINATION, { next, total });
          commit(SET_LOADING_MORE, false);
          return state.merchants;
        })
        .catch((error) => {
          console.log(error);
          commit(SET_LOADING_MORE, false);
          return Promise.reject(error);
        });
    },
    [SEARCH_MERCHANTS]({ commit }, params) {
      const search = (params?.search || '').trim();
      if (!search) {
        commit(SET_MERCHANTS_SEARCH_RESULTS, []);
        return Promise.resolve([]);
      }
      commit(SET_MERCHANTS_SEARCH_LOADING, true);
      const queryParams = { ...params, list_view: 'True', search };
      return CompaniesService.query(queryParams)
        .then((response) => {
          const list = Array.isArray(response?.data) ? response.data : [];
          commit(SET_MERCHANTS_SEARCH_RESULTS, list);
          commit(SET_MERCHANTS_SEARCH_LOADING, false);
          return list;
        })
        .catch((error) => {
          console.log(error);
          commit(SET_MERCHANTS_SEARCH_RESULTS, []);
          commit(SET_MERCHANTS_SEARCH_LOADING, false);
          return Promise.reject(error);
        });
    },
    [CLEAR_MERCHANTS_SEARCH]({ commit }) {
      commit(SET_MERCHANTS_SEARCH_RESULTS, []);
      commit(SET_MERCHANTS_SEARCH_LOADING, false);
    },
    [GET_ALL_MERCHANT_EMAIL_CONFIGS_LIST]({ commit }, params) {
      return new Promise((resolve, reject) => {
        commit(SET_LOADING, true);
        CompaniesService.get(params)
          .then(({ data }) => {
            data.forEach(function (obj) {
              obj.name = obj.reminder_workflow + " : " + obj.business_name;
            });
            data.sort(function (a, b) {
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
              }
              return 0;
            });
            commit(SET_ALL_EMAIL_CONFIGS, data);
            commit(SET_LOADING, false);
            resolve(data);
          })
          .catch((error) => {
            commit(SET_LOADING, false);
            reject(error);
          });
      });
    },
  },
  getters: {
    merchants(state) {
      return state.merchants;
    },
    hasMoreMerchants(state) {
      return !!state.merchantsNextPageUrl;
    },
    merchantsLoadingMore(state) {
      return state.merchantsLoadingMore;
    },
  },
};
